import React, { useEffect, useState } from 'react';
import { Box, FormHelperText, InputLabel, OutlinedInput, ToggleButton, ToggleButtonGroup } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';
import ArticleIcon from '@mui/icons-material/Article';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { SearchableSelect } from '../../../components/searchable-select';
import CustomPageAppService from '../../../application/platform/apm/custom-page/custom-page-app-service';
import { LinkTargetMode, LinkTargetValue, changeLinkTargetMode } from './link-target-utils';

interface LinkTargetFieldProps {
    mode: LinkTargetMode;
    value: LinkTargetValue;
    onChange: (mode: LinkTargetMode, value: LinkTargetValue) => void;
    error?: string;
}

export function LinkTargetField({ mode, value, onChange, error }: LinkTargetFieldProps) {
    const [pages, setPages] = useState<{ id: number; label: string }[]>([]);
    const [loadingPages, setLoadingPages] = useState(false);

    useEffect(() => {
        setLoadingPages(true);
        CustomPageAppService.list({ page: 0, pageSize: 100 })
            .then((result) => setPages((result.items || []).map((p) => ({ id: p.id, label: `${p.title} (/${p.slug})${p.isPublished ? '' : ' — rascunho'}` }))))
            .catch(() => setPages([]))
            .finally(() => setLoadingPages(false));
    }, []);

    return (
        <Box>
            <InputLabel>Destino</InputLabel>
            <ToggleButtonGroup
                exclusive
                size="small"
                color="primary"
                value={mode}
                onChange={(_, next: LinkTargetMode | null) => next && onChange(next, changeLinkTargetMode(value, next))}
                sx={{ mb: 1.5 }}
            >
                <ToggleButton value="none"><BlockIcon fontSize="small" sx={{ mr: 0.75 }} />Nenhum</ToggleButton>
                <ToggleButton value="page"><ArticleIcon fontSize="small" sx={{ mr: 0.75 }} />Página do portal</ToggleButton>
                <ToggleButton value="url"><OpenInNewIcon fontSize="small" sx={{ mr: 0.75 }} />URL externa</ToggleButton>
            </ToggleButtonGroup>

            {mode === 'page' && (
                <SearchableSelect
                    options={pages}
                    value={value.customPageId}
                    onChange={(id) => onChange(mode, { customPageId: id ? Number(id) : undefined, url: undefined })}
                    placeholder="Selecione a página"
                    loading={loadingPages}
                    error={!!error}
                    noOptionsText="Nenhuma página encontrada"
                />
            )}
            {mode === 'url' && (
                <OutlinedInput
                    fullWidth
                    autoComplete="off"
                    placeholder="https://"
                    value={value.url || ''}
                    onChange={(e) => onChange(mode, { customPageId: undefined, url: e.target.value })}
                    error={!!error}
                />
            )}
            {error && <FormHelperText error>{error}</FormHelperText>}
        </Box>
    );
}
